import React, { useEffect } from 'react';

const AddToCartPopup = ({ product, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Cierra el popup después de 3 segundos
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed bottom-4 right-4 bg-white p-4 rounded-lg shadow-lg flex items-center space-x-4 z-50 animate-slideIn">
      <img src={product.image} alt={product.name} className="w-16 h-16 object-cover rounded-md" />
      <div>
        <p className="font-semibold text-gray-900">¡Agregado al carrito!</p>
        <p className="text-sm text-gray-600">{product.name}</p>
      </div>
      <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>
    </div>
  );
};

export default AddToCartPopup;